import { render } from "./ActivityCraftManagement.vue?vue&type=template&id=6b0c948c&scoped=true"
import script from "./ActivityCraftManagement.vue?vue&type=script&lang=js"
export * from "./ActivityCraftManagement.vue?vue&type=script&lang=js"

import "./ActivityCraftManagement.vue?vue&type=style&index=0&id=6b0c948c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0c948c"]])

export default __exports__